import { ColDef } from 'ag-grid-community';

export const myRequestsColumnDefs: ColDef[] = [
  {
    headerName: 'Request #',
    field: 'id',
    minWidth: 120,
    maxWidth: 120,
    cellRenderer: 'agGroupCellRenderer',
    headerClass: 'grid__header',
    initialSort: 'desc',
  },
  { field: 'type', headerClass: 'grid__header', maxWidth: 80 },
  { field: 'title', headerClass: 'grid__header' },
  {
    headerName: 'Author',
    field: 'requestor.fullName',
    headerClass: 'grid__header',
  },
  {
    headerName: 'App',
    valueGetter({ data }) {
      if (data?.issue.__typename === 'RequestItIssue') {
        return data?.issue.app.name;
      }
      return '';
    },
    headerClass: 'grid__header',
    initialHide: true,
    sortable: true,
  },
  {
    headerName: 'Department',
    valueGetter({ data }) {
      if (data?.issue.__typename === 'RequestItIssue') {
        return data?.issue.department.name;
      }
      return '';
    },
    headerClass: 'grid__header',
    sortable: true,
  },
  {
    field: 'createdAt',
    headerName: 'Date',
    headerClass: 'grid__header',
    sortable: true,
    maxWidth: 100,
  },
];

export const issuesSettingsColDefs: ColDef[] = [
  { field: 'issueType', initialWidth: 180 },
  {
    headerName: 'User',
    field: 'systemUser.fullName',
    initialWidth: 110,
  },
];
